module.exports = __webpack_public_path__ + "static/img/juan.f5b2958.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/juan.jpg
// module id = ejZp
// module chunks = 1